import { getValuesByLastValue, getOptions, gradeConfig } from '_platform/output/area/areaUtils';

export default {
  name: 'DsfAreaSelectByInline',
  props: {
    isDesign: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    // 一行几列，0表示自动
    inlineColumn: {
      type: Number,
      default: 0
    },
    superCode: {
      type: String,
      default: "000000000000"
    },
    // 精确度，选择到第几级: 0-省、1-市、2-区县、3-街道、4-村居
    accuracy: {
      type: Number,
      default: 4,
    },
    // 输入框中是否显示选中值的完整路径
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 是否可选择任意一级
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 提交数据是否包含别名
    postHasAlias: {
      type: Boolean,
      default: false
    },
    // 选项中显示的文本字段
    optionsTextField: {
      type: String,
      default: "name"
    },
    //选中时显示的值
    selectedTextField: {
      type: String,
      default: "name"
    },
    disabled: Boolean,
    readonly: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    // 编码规则
    codeRule: {
      type: Object,
      default() {
        return {
          rootCode: '000000000000', // 根节点编码
          isFull: false, // 是否填充0
          inferCode: null // 推导编码的方法，默认为空
        };
      }
    },
    // 懒加载自定义方法, 参数（node, params, resolve）
    lazyLoadData: {
      type: Function,
      default: null
    },
    // 提示文字展示在文本框外
    placeholderInOuter: {
      type: Boolean,
      default: false
    },
    // 是否显示父级选项
    showSuperSelect: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
  },
  data() {
    this.gradeConfig = gradeConfig;
    return {
      valueCopy: {},
      selectValue: {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null
      },
      hideValue: {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {}
      },
      options: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: []
      },
      itemLoading: [
        false,
        false,
        false,
        false,
        false,
      ],
    }
  },
  computed: {
    realSuperCode() {
      let code = this.superCode.trim();
      if (!/^([\d\w]+\.)*[\d\w]+$/.test(code) || code == this.codeRule.rootCode) {
        return this.codeRule.rootCode;
      }
      code = code.split('.');
      if (code.length == 1) {
        code = getValuesByLastValue(code[0], this.codeRule);
      }
      return code.join('.');
    },
    rangeStart() {
      let codes = this.realSuperCode.split('.');
      let r = codes.length - 1;
      if (r > 0 && this.showSuperSelect) {
        r--;
      }
      return r;
    },
    rangeEnd() {
      let r = this.accuracy;
      return r > 4 ? 4 : r;
    },
    rangeCopy() {
      let res = [];
      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        res.push(i);
      }
      console.log(this.superCode, this.realSuperCode, res);
      return res;
    },
    selectStyle() {
      let {inlineColumn, rangeCopy} = this;
      let l = rangeCopy.length;
      let res = {width:'100%'};
      if (!inlineColumn) {
        res.width = `calc(100% / ${l} - 10px)`;
        res['min-width'] = '240px';
      } else if (inlineColumn > 1) {
        res.width = `calc(100% / ${inlineColumn} - 10px)`;
      }
      return res;
    }
  },
  watch: {
    'value.value': {
      handler(to) {
        if (!this.isDesign && to != this.valueCopy.value) {
          this.valueCopy = this.value;
          this.valueChange();
        }
      },
      immediate: true
    },
  },
  render(h) {
    let children = [];
    _.each(this.rangeCopy, n => {
      let preValue = n ? this.selectValue[n - 1] : undefined;
      let value = this.selectValue[n];
      let option = this.options[n];
      let hideValue = this.hideValue[n];
      let gradeConfig = this.gradeConfig[n];
      let disabled = this.disabled || this.itemLoading[n] || (preValue === null || !option.length)
      let placeholder = this.itemLoading[n] ? '加载中...' : this.placeholderInOuter ? '请选择' : gradeConfig.zhName;
      children.push(
        <div class="dsf-area-select-by-inline-select" style={this.selectStyle}>
          <el-select
            value={value?.areacode}
            disabled={disabled}
            filter-method={e => this.filterMethod(e, n, option)}
            placeholder={placeholder}
            size={this.size}
            filterable
            clearable
            on={{clear: () => this.selectClear(n)}}>
            {
              _.map(option, item => {
                return (
                  <el-option
                    label={item[this.selectedTextField] || item.name}
                    value={item.areacode}
                    show={!hideValue[item.areacode]}
                    nativeOn={{click: () => this.handleSelect(n, item)}}>
                    {item[this.optionsTextField] || item.name}
                  </el-option>
                );
              })
            }
          </el-select>
          {this.placeholderInOuter && <span class="__placeholder">{gradeConfig.zhName}</span> }
        </div>
      );
    });
    if (this.$scopedSlots.default) {
      children.push(this.$scopedSlots.default({style: this.selectStyle}));
    }
    return (
      <div class="dsf-area-select-by-inline">
        <div class="dsf-area-select-by-inline-warp">
          {children}
        </div>
      </div>
    );
  },
  created() {
    if (!this.isDesign) {
      this.$set(this.itemLoading, this.rangeStart, true);
      this.getData({root: true, level: 0}, list => {
        this.$set(this.options, this.rangeStart, list);
        this.valueChange();
        this.$set(this.itemLoading, this.rangeStart, false);
      });
    }
  },
  methods: {
    getDefaultValue() {
      let res = {text: "", value: ""};
      if (this.postHasAlias) {
        res.alias = "";
      }
      return res;
    },
    filterMethod(s, n, options) {
      s = s.trim();
      let hideValue = {}
      _.each(options, it => {
        if (it.areacode.indexOf(s) == -1 && it.name.indexOf(s) == -1 && it.alias.indexOf(s) == -1) {
          hideValue[it.areacode] = true;
        }
      });
      this.$set(this.hideValue, n, hideValue);
    },
    valueChange() {
      let rangeStart = this.rangeStart;
      let value = this.valueCopy.value;
      let options = this.options[rangeStart];
      if (!value) {
        this.selectClear(rangeStart);
      } else if (options.length) {
        let ids = getValuesByLastValue(value, this.codeRule).slice(1);
        let item = _.find(options, it => it.areacode == ids[rangeStart]);
        if (item) {
          this.handleSelect(rangeStart, item, ids);
        }
      }
    },
    selectClear(n) {
      this.$set(this.selectValue, n, null);
      for (let i = n + 1; i <= this.rangeEnd; i++) {
        this.$set(this.options, i, []);
        this.$set(this.selectValue, i, null);
      }
      this.handleChange();
    },
    handleSelect(n, data, ids) {
      for (let i = n + 1; i <= this.rangeEnd; i++) {
        this.$set(this.selectValue, i, null);
      }
      this._handleSelect(n, data, ids);
    },
    _handleSelect(n, data, ids) {
      this.$set(this.selectValue, n, data);
      if (n == this.rangeEnd) {
        this.handleChange();
        return;
      }
      this.$set(this.itemLoading, n + 1, true);
      this.getData({
        root: false,
        level: n - this.rangeStart + 1,
        data
      }, list => {
        if ((!ids && this.checkStrictl) || !list.length) {
          this.$set(this.options, n + 1, list);
          this.$set(this.selectValue, n + 1, null);
          for (let i = n + 2; i <= this.rangeEnd; i++) {
            this.$set(this.options, i, []);
            this.$set(this.selectValue, i, null);
          }
          this.handleChange();
        } else {
          let item = ids ? _.find(list, it => it.areacode == ids[n + 1]) : list[0];
          this.$set(this.options, n + 1, list);
          if (item) {
            this.$set(this.selectValue, n + 1, item);
            this._handleSelect(n + 1, item, ids);
          }
        }
        this.$set(this.itemLoading, n + 1, false);
      });
    },
    handleChange() {
      let selectValue = _.filter(this.selectValue, v => v !== null);
      let res = this.getDefaultValue();
      if (selectValue.length > 0) {
        let text = [], alias = [];
        _.each(selectValue, data => {
          text.push(data.name);
          alias.push(data.alias);
        });
        res = {
          text: this.showAllLevels ? text.join("-") : _.last(text),
          value: _.last(selectValue).areacode
        };
        if (this.postHasAlias) {
          res["alias"] = this.showAllLevels ? alias.join("-") : _.last(alias);
        }
      }
      if (res.value !== this.valueCopy.value && (res.value || this.valueCopy.value)) {
        this.valueCopy = res;
        this.$emit('input', res);
        this.$nextTick(() => {
          this.$emit('change', res);
        });
      }
    },
    getData(node, resolve) {
      let { root, data } = node;
      let ids, level;
      if (root) {
        ids = this.superCode;
        level = this.rangeStart + 1;
      } else {
        let { treeinfo_globalid, treeinfo_level } = data;
        ids = treeinfo_globalid;
        level = treeinfo_level;
      }
      if (level > this.rangeEnd + 1) {
        resolve([]);
        this.firstLoading = false;
        this.__queen = undefined;
        return;
      }
      if (this.lazyLoadData) {
        return this.lazyLoadData(node, {
          ids,
          endRange: level + 1,
          startRange: level + 1
        }, resolve);
      }
      getOptions.call(this, {
        ids,
        endRange: level + 1,
        startRange: level + 1
      }, (list) => {
        if (level === this.rangeEnd + 1) {
          list.forEach((l) => (l.leaf = true));
        }
        resolve(list);
        this.firstLoading = false;
        this.$nextTick(() => {
          this.__queen?.();
          this.__queen = undefined;
        })
      });
    },
  }
};